import { createSlice } from "@reduxjs/toolkit";

const RegistrationSlice = createSlice({
  name: "login",
  initialState: {
    isGettingUser: false,
    currentUser: null,
    isUserGettingError: false,

    /* SignUp */
    signUpLoading: false,
    signUpError: "",
    signUpSuccessfully: null,

    /* Login */

    loginInLoading: false,
    loginInError: "",
    loginSuccessfully: null,
  },
  reducers: {
    signUpStart: (state) => {
      state.signUpLoading = true;
      state.signUpError = null;
      state.currentUser = null;
    },
    signUpSuccess: (state, action) => {
      state.signUpLoading = false;
      state.signUpSuccessfully = action.payload;
      state.signUpError = null;
    },
    signupErr: (state, action) => {
      state.signUpLoading = false;
      state.currentUser = null;
      state.signUpError = action.payload;
    },
    /* login */
    loginStart: (state) => {
      state.loginInLoading = true;
      state.loginInError = "";
    },
    loginSuccess: (state, action) => {
      state.loginInLoading = false;
      state.loginSuccessfully = action.payload;
      state.loginInError = "";
    },
    loginErr: (state, action) => {
      state.loginInLoading = false;
      state.loginInError = action.payload;
      state.currentUser = null;
    },
    /* fetch user */
    getUserLoading: (state) => {
      state.isGettingUser = true;
      state.isUserGettingError = null;
      state.currentUser = null;
    },
    getUserInfo: (state, action) => {
      state.currentUser = action.payload;
      state.isGettingUser = false;
      state.isUserGettingError = null;
    },
    getUserError: (state, action) => {
      state.isGettingUser = false;
      state.isUserGettingError = action.payload;
      state.currentUser = null;
    },
    signOut: (state) => {
      state.currentUser = null;
    },
  },
});

export const {
  signUpStart,
  signUpSuccess,
  signupErr,
  loginStart,
  loginSuccess,
  loginErr,
  signOut,
  /* getting user */
  getUserInfo,
  getUserLoading,
  getUserError,
} = RegistrationSlice.actions;

export default RegistrationSlice.reducer;
